import { render, staticRenderFns } from "./ElementaryZoneItem.component.html?vue&type=template&id=bf5050be&scoped=true&external"
import script from "./ElementaryZoneItem.component.ts?vue&type=script&lang=ts&external"
export * from "./ElementaryZoneItem.component.ts?vue&type=script&lang=ts&external"
import style0 from "./ElementaryZoneItem.component.scss?vue&type=style&index=0&id=bf5050be&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5050be",
  null
  
)

export default component.exports